<template>
    <form @submit.prevent="">
        <h4 class="modal-header">
          Create index
          <!-- <button type="button" tabindex="-1" class="close wj-hide">&times;</button> -->
        </h4>
        <div class="modal-body">
          <label>
            Index name:
          </label>
            <div class="form-group"><div style="width:90%" class="input-group">
            <input class="form-control form-control-sm indexName name-input" style="margin-left:0;" v-model="name" /></div></div>
          <br />
          <label>
            Columns:
          </label>
            <div class="form-group" v-for="(fld, index) in columns" v-bind:key="fld.name">
              <div class="input-group">
                 <!-- <wj-combo-box :itemsSource="GetTblFields(fld.name, columns)" v-model="fld.name" :displayMemberPath="'name'" :isAnimated="true" ></wj-combo-box> -->
                <v-select style="width:90%;margin-left:0;" v-model="fld.name" :reduce="o => o.name" label="name" :options="GetTblFields(fld.name, columns)"></v-select>
               
                <div class="input-group-append"><a class="close" style="width:16px;margin:8px;" v-on:click="columns.splice(index,1)">×</a></div>
              </div>
            </div>
          <br />
          <div>
              <input type="button" class="btn btn-secondary" v-if="columns.length < maxColumnsLength " value="Add column" v-on:click="columns.push({})" />
            </div>
        </div>
        <div class="modal-footer">
          <!-- <button class="btn btn-primary" v-on:click="Cancel">
            Cancel
          </button> -->
          <button class="btn btn-primary" v-on:click="CreateIndex()">
            Save
          </button>
        </div>
      </form>
</template>
<script>

import 'bootstrap/dist/css/bootstrap.css';
import '@grapecity/wijmo.styles/wijmo.css';
import '@grapecity/wijmo.vue2.core';
import '@grapecity/wijmo.vue2.input';
import { commonMixin } from '../common.js'

export default {
    mixins: [commonMixin],
    mounted(){
      setTimeout(function(){
          document.querySelector('.indexName').focus();
      },50)
    },
    data(){
        return {
            name: '',
            columns: [{}]
        }
    },
    props: {
        tab: {
            type: Object,
            required: true
        },
        state: {
            type: Object,
            required: true
        }
    },
    computed: {
      maxColumnsLength() {
        let l = 0;
        for (let i = 0; i < this.tab.table.fields.length && i <= 10; i++) {
          const e = this.tab.table.fields[i];
          if(e.subtype === 0)
              l++;
        }
        return l;
      }
    },
    methods:{
        GetTblFields(val, selected){
            //console.log('GetTblFields('+val+'). columns count:'+this.columns.length);
            var r = [];
            for (let i = 0; i < this.tab.table.fields.length; i++) {
                const e = this.tab.table.fields[i];
                if((!selected.find(a=>a.name == e.name) && e.subtype === 0) || e.name === val)
                    r.push(e);
            }
            return r;
        },
        CreateIndex(){
          console.log('CreateIndex()');
          if(!this.name){
            this.ShowAlert('Enter index name');
            return;
          }
          var r = [];
          for (let i = 0; i < this.columns.length; i++) {
            const e = this.columns[i];
            if(e.name)
              r.push(e.name);
          }
          //console.log('r', r);
          if(!r.length){
            this.ShowAlert('Enter at least one column');
            return;
          }
          console.log('creating index...');
          this.ExecScript(this.tab.db, `CREATE INDEX [${this.name}] ON [${this.tab.table.tablename}] (${r.join(',')}) `,response=>{
            if (!response.data[0].err){
              this.LoadDbFromServer(this.tab.db)
              this.ShowAlert('Saved');
            } else {
              this.ShowAlert(response.data[0].msg);
            }
          },true,this.tab.idconnect,this.state.guid)
        },
    },
}
</script>
<style scoped>
  .modal-footer {
    display: flex;
    justify-content: flex-start;
  }
  .name-input {
    margin: 5px;
  }
</style>